import type { Meter } from '../../../interfaces/Meter.interface';
import { type Actions, ActionType } from './meters.actions';
import { initialState, meterAdapter, type State } from './meters.state';

export function metersReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }

        case ActionType.FETCH_METERS: {
            return { ...state, isPending: true };
        }

        case ActionType.FETCH_METERS_SUCCEEDED: {
            return meterAdapter.setAll(action.payload.meters, { ...state, isLoaded: true, isPending: false });
        }

        case ActionType.FETCH_METERS_FAILED: {
            return { ...state, isLoaded: false, isPending: false };
        }

        case ActionType.CREATE_METER: {
            return meterAdapter.addOne(action.payload.meter, { ...state, isLoaded: true, isPending: false });
        }

        case ActionType.REMOVE_METER: {
            return meterAdapter.removeOne(action.payload.meterId, { ...state });
        }

        case ActionType.UPDATE_METER_PROPERTY: {
            const meter: Partial<Meter> = {
                [action.payload.propertyName]: action.payload.propertyValue
            };

            return meterAdapter.updateOne(
                {
                    id: action.payload.meterId,
                    changes: meter
                },
                state
            );
        }

        case ActionType.UPDATE_METER: {
            return meterAdapter.updateOne(
                {
                    id: action.payload.meterId,
                    changes: action.payload.meterUpdate
                },
                state
            );
        }

        default:
            return state;
    }
}
